module.exports = __webpack_public_path__ + "static/media/Payment Information-rafiki.fab30c01.png";